import { ImageMedia } from '../../services/getMediaFilesApi'

export const removePhotoByUrl = (
  photosToFilter: ImageMedia[],
  targetUrl: string,
) => {
  return photosToFilter.filter((photo) => photo.url !== targetUrl)
}
